
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell-your-parts",
      function () {
        return require("private-next-pages/sell-your-parts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell-your-parts"])
      });
    }
  